import { breakpoints } from '@bnnvara/breakpoints';
import styled from 'styled-components';

export const BrandTitleContainer = styled.div`
  height: 40px;
  width: 100%;
  background: ${({ theme }) => theme.primary.main};
  text-align: center;
  ${breakpoints.md} {
    height: 48px;
  }
`;

export const BrandTitle = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: 13px;
  line-height: 40px;
  font-weight: 700;
  color: #fff;

  ${breakpoints.md} {
    font-size: 18px;
    line-height: 48px;
    text-align: center;
  }
`;
